exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 991px) {\n.cards[data-v-580eef66] {\n    /* padding-top: 5vh; */\n}\n}\n", ""]);

// exports
